import Vue from "vue";

// When the request succeeds
const success = (data, context) => {
  context.status = 'success';
  context.loading = false;
};

// When the request fails
const failed = (context, error) => {
  context.status = 'error';
  context.loading = false;
};

export default (context, parameters) => {
  return Vue.$http
    .post("confirm-3ds-authentication", parameters)
    .then((response) => {
      if (response.status === 200) {
        success(response.data, context);
      }
    })
    .catch((error) => {
      failed(context, error);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/payment/confirm3dsAuthentication.js